import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileType, FileTypeService } from '@shared/models/file-types';
import { IStorageFile } from '@shared/models/storage';
import { FileSizePipe } from '@shared/pipes/file-size.pipe';
import { RelativeTimePipe } from '@shared/pipes/relative-time.pipe';

@Component({
	selector: 'app-job-card-attachment',
	imports: [CommonModule, RelativeTimePipe, FileSizePipe],
	templateUrl: './job-card-attachment.component.html',
	styleUrl: './job-card-attachment.component.scss',
})
export class JobCardAttachmentComponent {
	@Input() attachment: IStorageFile;
	@Input() readonly: boolean = false;
	@Output() removeAttachment = new EventEmitter<IStorageFile>();
	@Output() editAttachmentDescription = new EventEmitter<IStorageFile>();

	getFileIcon(contentType: string | undefined): string {
		return FileTypeService.getFileIcon(contentType as FileType);
	}
}
